export default __webpack_public_path__ + "static/media/watchone.561f0ebc.jpg";